export const ADMINS = ['ArRuTVAbh3TPxZlXPvGtCFbYAkG3'];

export function isAdmin(userId: string): boolean {
    return ADMINS.some(el => el === userId);
}
